import React from "react";
import { Box, TextField, Typography } from "@mui/material";
import { commonStyles } from "../../../../assets/MUIStyles/commonStyles";
import DebouncedInput from "../../../../common/components/DebouncedTextfield";

const FirstStep = ({ agent, handleChange, selectedAccount, setAgent }) => {
  const {
    agentName,
    organisationName,
    greetingMessage,
    voicemailMessage,
    inboundGreetingMessage,
    agentType,
  } = agent;
  return (
    <>
      <Box
        className="flex-between"
        sx={{
          mb: 2,
          width: "100%",
          gap: 2,
        }}
      >
        <Box
          sx={{
            width: "100%",
          }}
        >
          <Typography className="font-14-grey" gutterBottom>
            Agent Name
          </Typography>
          <TextField
            name="agentName"
            value={agentName}
            onChange={handleChange}
            variant="outlined"
            fullWidth
            placeholder="Enter the name of the agent"
            sx={commonStyles.inputField}
          />
        </Box>
        <Box
          sx={{
            width: "100%",
          }}
        >
          <Typography className="font-14-grey" gutterBottom>
            Organisation Name
          </Typography>
          <TextField
            name="organisationName"
            value={organisationName}
            onChange={handleChange}
            variant="outlined"
            fullWidth
            placeholder="Enter the organisation name"
            sx={commonStyles.inputField}
          />
        </Box>
      </Box>
      {agentType === "call" ? (
        <>
          <Box
            sx={{
              mb: 2,
            }}
          >
            <Typography className="font-14-grey" gutterBottom>
              Greeting Message
            </Typography>
            <TextField
              name="greetingMessage"
              value={greetingMessage}
              onChange={handleChange}
              variant="outlined"
              fullWidth
              multiline
              rows={4}
              placeholder="Eg: “Hi {FirstName}, this is Olivia from XYZ organisation”"
              sx={commonStyles.inputField}
            />
          </Box>
          <Box
            sx={{
              mb: 2,
            }}
          >
            <Typography className="font-14-grey" gutterBottom>
              Voicemail Message
            </Typography>
            <TextField
              name="voicemailMessage"
              value={voicemailMessage}
              onChange={handleChange}
              variant="outlined"
              fullWidth
              multiline
              rows={4}
              placeholder="Eg: “Hi {FirstName}, this is Olivia from XYZ organisation”"
              sx={commonStyles.inputField}
            />
          </Box>
          {selectedAccount?.params?.inboundEnable && (
            <Box>
              <Typography className="font-14-grey" gutterBottom>
                Inbound Message
              </Typography>
              <TextField
                name="inboundGreetingMessage"
                value={inboundGreetingMessage}
                onChange={handleChange}
                variant="outlined"
                fullWidth
                multiline
                rows={4}
                placeholder="Eg: “Hi {FirstName}, this is Olivia from XYZ organisation”"
                sx={commonStyles.inputField}
              />
            </Box>
          )}
        </>
      ) : (
        <Box>
          <Typography className="font-14-grey" gutterBottom>
            <span className="text-capitalize"> {agentType} </span>Context
          </Typography>
          <DebouncedInput
            initialValue={agent?.context}
            onDebouncedUpdate={(val) => {
              let replacedString = val
                .replace(/\{\{OrganizationName\}\}/g, agent.organisationName)
                .replace(/\{\{AgentName\}\}/g, agent.agentName);

              setAgent((prev) => ({ ...prev, context: replacedString }));
            }}
            sx={commonStyles.inputField}
          />
        </Box>
      )}
    </>
  );
};

export default FirstStep;
